import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Box } from "@chakra-ui/react"
import { DashboardPage, DealManagerDashboardPage, LoginPage, NdaPage, SmsOptInPage, SmsTermsPage } from "@/pages"
import { NavOption } from "@/types"
import { ProtectedRoute } from "./ProtectedRoute"
import { FeatureGate } from "./FeatureGate"

export const Router = () => {
  return (
    <Box>
      <BrowserRouter>
        <Routes>
          <Route path="/compliance" element={ <ProtectedRoute><FeatureGate><DashboardPage currentNavOption={NavOption.COMPLIANCE} /></FeatureGate></ProtectedRoute> } />
          <Route path="/deals" element={ <ProtectedRoute><FeatureGate><DashboardPage currentNavOption={NavOption.CURRENT_OFFER} /></FeatureGate></ProtectedRoute> } />
          <Route path="/documents" element={ <ProtectedRoute><FeatureGate><DashboardPage currentNavOption={NavOption.DOCUMENTS} /></FeatureGate></ProtectedRoute> } />
          <Route path="/login" element={ <LoginPage /> } />
          {/* PUBLIC, no login and no FeatureGate: carrier reviewers (TFV) must be able to open these. */}
          <Route path="/sms-opt-in" element={ <SmsOptInPage /> } />
          <Route path="/sms-terms" element={ <SmsTermsPage /> } />
          <Route path="/nda" element={ <FeatureGate><NdaPage /></FeatureGate> } />
          <Route path="/resources" element={ <ProtectedRoute><FeatureGate><DashboardPage currentNavOption={NavOption.RESOURCES} /></FeatureGate></ProtectedRoute> } />
          <Route path="/taxes" element={ <ProtectedRoute><FeatureGate><DashboardPage currentNavOption={NavOption.TAX_CALCULATION} /></FeatureGate></ProtectedRoute> } />
          <Route path="/dashboard" element={ <ProtectedRoute><DealManagerDashboardPage currentNavOption={NavOption.DASHBOARD} /></ProtectedRoute> } />
          <Route path="/clients" element={ <ProtectedRoute><DealManagerDashboardPage currentNavOption={NavOption.CLIENTS} /></ProtectedRoute> } />
          <Route path="/clients/:clientId" element={ <ProtectedRoute><DealManagerDashboardPage currentNavOption={NavOption.CLIENT} /></ProtectedRoute> } />
          <Route path="/eso/deals" element={ <ProtectedRoute><DealManagerDashboardPage currentNavOption={NavOption.DEALS} /></ProtectedRoute> } />
          <Route path="/account" element={ <ProtectedRoute><DashboardPage currentNavOption={NavOption.ACCOUNT} /></ProtectedRoute> } />
          <Route path="/payment" element={ <ProtectedRoute><DashboardPage currentNavOption={NavOption.PAYMENT_CENTER} /></ProtectedRoute> } />
          <Route path="/secondary" element={ <ProtectedRoute><DashboardPage currentNavOption={NavOption.SECONDARY} /></ProtectedRoute> } />
          <Route path="*" element={<Navigate replace to="/login" />} />
        </Routes>
      </BrowserRouter>
    </Box>
  )
}